import z, { literal } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';

import { BaseConfigurationSchema } from './base-configuration.schema';

import { AWARD_TYPES } from '../types';

export const SweepstakesEarningMechanismSchema = BaseConfigurationSchema.extend({
  awardType: literal(AWARD_TYPES.SWEEPSTAKES),
});

export type SweepstakesFormValues = z.infer<typeof SweepstakesEarningMechanismSchema>;

export const validateSweepstakesForm = makeValidate(SweepstakesEarningMechanismSchema);
